import styled, { css } from 'styled-components';

const CartItemContainer = styled.div<{ $hasOffer: boolean }>`
  width: 100%;
  background-color: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  padding: 1rem;

  ${({ $hasOffer }) =>
    $hasOffer &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
`;

export default CartItemContainer;
